// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2EJNc","productName":"Table_productName__2eILz"};